import { render, staticRenderFns } from "./PocketIsOnMaintenanceDialog.vue?vue&type=template&id=0bdcee10&scoped=true&"
import script from "./PocketIsOnMaintenanceDialog.vue?vue&type=script&lang=ts&"
export * from "./PocketIsOnMaintenanceDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PocketIsOnMaintenanceDialog.vue?vue&type=style&index=0&id=0bdcee10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdcee10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VContainer,VDialog,VIcon,VRow})
